import { useContext } from 'react';
import { GeneralAppStateContext } from '../contexts/general-app-state';

const useGeneralAppState = () => useContext(GeneralAppStateContext);

export default useGeneralAppState;
